import React, { useState } from 'react'
import { Row, Col, Card, CardBody, Button, CardTitle, Spinner, FormGroup, Form, CardHeader, Table, Pagination, PaginationItem, PaginationLink, Modal, ModalHeader, ModalBody, DropdownToggle, DropdownMenu, UncontrolledDropdown, Label } from 'reactstrap';
import http from '../../CommonAxios'
import Swal from 'sweetalert2';
import { useForm } from 'react-hook-form';
import { checkData } from '../../ObjectExist';

const AddBanner = (props) => {
    const [loader, setLoader] = useState(false);
    const [image, setImage] = useState("");

    const { register: bannerInput, handleSubmit: bannerSubmit, formState: { errors }, reset } = useForm();
    const handleFileInput = (e) => {
        setImage(e.target.files[0])
    }
    const onAddBanner = (data) => {
        setLoader(true);
        let formData = new FormData();
        formData.append("admin_id", checkData(props.user) ? props.user.id : '');
        formData.append("title", data.title);
        formData.append("link", data.link);
        formData.append("image", image);
        formData.append("status", data.status);

        http.post(`banner/add`, formData).then((res) => {
            setLoader(false);
            if (res.data.s === 1) {
                Swal.fire({ icon: 'success', title: 'Success', text: res.data.msg, });
                props.setAddmodal(false); props.onApiInteg(); reset();
            } else {
                Swal.fire({ icon: 'error', title: 'Error', text: res.data.message, });
            }
        }).catch(function (err) {
            setLoader(false);
        });
    };
    return (
        <>
            {loader && <div className="formLoader"><Spinner /></div>}
            <Modal isOpen={props.addmodal} toggle={props.addmodal} scrollable={true} size="lg" className='addModal'>
                <ModalHeader toggle={props.toggleAdd}>Add New Banner</ModalHeader>
                <ModalBody>
                    <Form onSubmit={bannerSubmit(onAddBanner)} >
                        <Row className="mx-0  addModal">
                            <Col sm={6}>
                                <FormGroup>
                                    <Label for="title">Enter title<span className="text-danger">*</span></Label>
                                    <input {...bannerInput("title", { required: 'Please Enter Title' })} className="form-control-sm form-control" placeholder="Enter title*" id="title" />
                                </FormGroup>
                            </Col>
                            <Col sm={6}>
                                <FormGroup>
                                    <Label for="link">Enter Link<span className="text-danger">*</span></Label>
                                    <input {...bannerInput("link", { required: 'Please Enter Link' })} className="form-control-sm form-control" placeholder="Enter Link*" id="link" />
                                </FormGroup>
                            </Col>
                            <Col sm={6}>
                                <FormGroup>
                                    <Label for="uploadLogo_add">Upload Image</Label>
                                    <input {...bannerInput("bannerImage", { required: false })} type="file" onChange={handleFileInput} accept=".jpg, .jpeg, .png" className="form-control-sm form-control" id="uploadLogo_add" />
                                    <span className="text-info d-block">1920/600</span>
                                    {errors.bannerImage && <span className="text-danger d-block error">{errors.bannerImage.message}</span>}
                                </FormGroup>
                            </Col>
                            <Col sm={6}>
                                <FormGroup>
                                    <FormGroup check className="pl-0">
                                        <Label>Status<span className="text-danger">*</span></Label>
                                        <div>
                                            <span className="form-check2 me-3">
                                                <input className="mx-2" {...bannerInput("status", { required: true })} type="radio" value="1" id="active_add" defaultChecked />
                                                <Label for="active_add">Active</Label>
                                            </span>
                                            <span className="form-check2">
                                                <input className="mx-2" {...bannerInput("status", { required: true })} type="radio" value="0" id="inactive_add" />
                                                <Label for="inactive_add">InActive</Label>
                                            </span>
                                        </div>
                                    </FormGroup>
                                </FormGroup>
                            </Col>

                            <Col sm={12} className="text-right">
                                <Button className="vs-btn border-0" color="primary">Save</Button>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
        </>
    )
}

export default AddBanner